import React, { useState, useEffect, useRef } from "react";
import ConversionFunnel from "../components/ConversionFunnel.jsx";
import KpiCard from "../components/KpiCard";
import ConversionRateTrend from "../components/ConversionRateTrend.jsx";
import SwiggyLogo from "../assets/Swiggy.png";
import ReusableBarChart from "../components/ReusableBarChart";
import TrendCharts from "../components/TrendCharts.jsx";
import AdsPerformance from "../components/AdsPerformance.jsx"
import UserSegmentDonut from "../components/UserSegmentDonut.jsx";
import OrdersTrendChart from "../components/OrdersTrendChart.jsx";
import   "../styles/CustomerInsights.css"
import PieCharts from "../components/PieCharts.jsx";
import MenuTable from "../components/MenuTable.jsx"
import MenuInsights from "../components/MenuInsights.jsx"
import MealPieCharts from "../components/MealPieChart.jsx";
import { api } from "../utils/api";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";







const RESTAURANTS = [
  { value: "Mumbai_Ladu_Samrat", label: "Mumbai Ladu Samrat" },
  { value: "Shobhaa_Only_Veg", label: "Shobhaa Only Veg" },
  { value: "R_Bhagat_Tarrachand", label: "R Bhagat Tarrachand" },
  { value: "MM_Mithaiwala", label: "MM Mithaiwala" },
  { value: "Mm_Mithaiwala_Fast_Food", label: "Mm Mithaiwala Fast Food" },
  { value: "Zaika_Fun_Dining", label: "Zaika Fun Dining" },
  { value: "Annamaya", label: "Annamaya" },
  { value: "Aegyo_-_Cafe_And_Bakehouse", label: "Aegyo - Cafe And Bakehouse" },
  { value: "Bhagwati_Pav_Bhaji", label: "Bhagwati Pav Bhaji" }, 
  { value: "Bhagwati_Veg_Restaurant", label: "Bhagwati Veg Restaurant" }
];


export default function OrdersFunnelPage() {
  const [swiggyData, setSwiggyData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [currentMonthData, setCurrentMonthData] = useState(null);
  const [previousMonthData, setPreviousMonthData] = useState(null);
  const [currentNetSales, setCurrentNetSales] = useState(null);
  const [previousNetSales, setPreviousNetSales] = useState(null);
  const [resturantHeader, setRestaurantHeader] =  useState(null)
  const [activeMetric, setActiveMetric] = useState("orders");
  const [selectedRestData, setselectedRestData] = useState("");
  const [periodList, setPeriodList] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [selectedPeriodSecFunnel, setSelectedPeriodSecFunnel] = useState("");
  const [selectedMenuOpen, setSelectMenuOpen] = useState("")
  const [selectedCartBuild, setSelectCartBuild] = useState("")
  const [funnelOrder, setfunnelOrder] = useState("")
  const [selectedMenuOpenSecond, setSelectMenuOpenSecond] = useState("")
  const [selectedCartBuildSecond, setSelectCartBuildSecond] = useState("")
  const [funnelOrderSecond, setfunnelOrderSecond] = useState("")
  const [restaurant, setRestaurant] = useState("");
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [headerMonth, setheaderMonth] = useState()
  const [restaurantNames, setrestaurantNames] = useState("")
  const [selectheaderDate, setHeaderDates] = useState("")
  const [allrestID, setAllSetID] = useState([])
  const [selectedRestId, setRestId] = useState('')
  const [overallConvFunnel, setOverallConvFunnel] = useState("")
  const [overallSecConvFunnel, setSecOverallConvFunnel] = useState("")



  const dropdownRef = useRef(null);

  const dashboardRef = useRef();

  const downloadPDF = async () => {
    const input = dashboardRef.current;

    const canvas = await html2canvas(input, {
      scale: 2,
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight =
      (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    pdf.save("restaurant-dashboard.pdf");
  };



  
  useEffect(() => {
    async function loadData() {
      try {
        setIsLoading(true);
  
        // Dropdown API
        const dropdownData = await api("/swiggyrestaurants-dropdown");
  
        setrestaurantNames(dropdownData)
  
        // Selected restaurant
        const firstRestaurant = dropdownData?.[0]?.value;
  
        if (!firstRestaurant) {
          console.error("Restaurant not found");
          return;
        }
  
        // Details API
        const detailsData = await api(
          `/swiggyrestaurant/${firstRestaurant}`
        );
  
  
        const summary = detailsData?.summary || [];

        const restIDs = detailsData.available_rest_ids || []

        setAllSetID(restIDs)

  
        const selectRestId =
        restIDs.length > 1
          ? "All"
          : restIDs[0] || "";
  
       setRestId(selectRestId);
  
      // No summary data
      if (summary.length === 0) {
        console.warn("No summary data found");
  
        setCurrentMonthData(null);
        setPreviousMonthData(null);
  
        return;
      }

  
        // Store full API response
        setSwiggyData(detailsData);
  
        // Period list
        const allPeriods = dateConvert(summary);
        setPeriodList(allPeriods);
        setHeaderDates(allPeriods)
  
        // Latest months
        const currentMonth = summary[summary.length - 1];
        const prevMonth =
        summary.length > 1
          ? summary[summary.length - 2]
          : null;

    

        const overallConversion = ((currentMonth?.orderMake / currentMonth?.menuOpen) * 100).toFixed(1)
        const overallSecConversion = ((prevMonth?.orderMake / prevMonth?.menuOpen) * 100).toFixed(1)



        setOverallConvFunnel(overallConversion)
        setSecOverallConvFunnel(overallSecConversion)

  
        // Net sales
        const currNetSale =
          (currentMonth?.gmv || 0) -
          (currentMonth?.discount || 0) - (currentMonth?.swiggyBurn || 0);
  
        const prevNetSale =
          (prevMonth?.gmv || 0) -
          (prevMonth?.discount || 0) - (prevMonth?.swiggyBurn || 0);

        setselectedRestData(summary)

  
        // Header
        setRestaurantHeader(
          detailsData?.restaurant_name || ""
        );
  
        // Net sales
        setCurrentNetSales(currNetSale);
        setPreviousNetSales(prevNetSale);
  
        // Month data
        setCurrentMonthData(currentMonth);
        setPreviousMonthData(prevMonth);
  
        // Funnel current
        setSelectMenuOpen(currentMonth?.menuOpen || 0);
        setSelectCartBuild(currentMonth?.cartbuild || 0);
        setfunnelOrder(currentMonth?.orderMake || 0);
  
        // Funnel previous
        setSelectMenuOpenSecond(prevMonth?.menuOpen || 0);
        setSelectCartBuildSecond(prevMonth?.cartbuild || 0);
        setfunnelOrderSecond(prevMonth?.orderMake || 0);
  
        // Periods
        setSelectedPeriod(currentMonth?.period || "");
        setSelectedPeriodSecFunnel(prevMonth?.period || "");
        setheaderMonth(currentMonth?.period || "");
  
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setIsLoading(false);
      }
    }
  
    loadData();
  }, []);



  // useEffect(() => {
  //   api('/swiggyData')
  //   .then(data => {
  //     setTimeout(() => {
  //       setSwiggyData(data);
  //       setIsLoading(false);
  //     }, 1000);
  //     const resData = data.zaika_fun_dining
  //     const allperiods = dateConvert(resData)
  //     setPeriodList(allperiods)

  //     console.log(typeof(data),data)

  //     const currentMonth = resData[resData.length - 1]
  //     const prevMonth = resData[resData.length -2]
  //     const currNetSale = currentMonth.gmv - currentMonth.discount
  //     const prevNetSale = prevMonth.gmv - prevMonth.discount

  //     setselectedRestData(resData)
  //     setRestaurantHeader(currentMonth.rest_name)
  //     setCurrentNetSales(currNetSale)
  //     setPreviousNetSales(prevNetSale)
  //     setCurrentMonthData(currentMonth)
  //     setPreviousMonthData(prevMonth)
  //     setSelectMenuOpen(currentMonth.menuOpen)
  //     setSelectCartBuild(currentMonth.cartbuild)
  //     setfunnelOrder(currentMonth.orderMake)
  //     setSelectMenuOpenSecond(prevMonth.menuOpen)
  //     setSelectCartBuildSecond(prevMonth.cartbuild)
  //     setfunnelOrderSecond(prevMonth.orderMake)
  //     setSelectedPeriod(currentMonth.period)
  //     setSelectedPeriodSecFunnel(prevMonth.period)
  //     setheaderMonth(currentMonth.period)
      


  //   })
  //     .catch(console.error);
  // }

  // , []);

  const formatPeriod = (period) => {

    const [year, month] = period.split("-");
  
    const date = new Date(year, month - 1); // month -1 because JS months start from 0
  
    return date.toLocaleString("en-US", {
      month: "short",
      year: "numeric",
    });
  };
  


  const dateConvert = (resData) =>{
    return resData.map(item => ({
      raw: item.period,
      formatted: formatPeriod(item.period)
    }))
  }


  
  const MIN_FUNNEL_VALUE = 1;
  
  const STATIC_FUNNEL_VALUES = [100, 70, 35];


 
  const funnellatestFunnelMetrics = [
    {
      label: `Menu Opens`,
      value: STATIC_FUNNEL_VALUES[0],
      actual: selectedMenuOpen,
      fill: "#6366F1"
    },
    {
      label: `Cart Builds`,
      value: STATIC_FUNNEL_VALUES[1],
      actual: selectedCartBuild,
      fill: "#22C55E"
    },
    {
      label: `Orders`,
      value: STATIC_FUNNEL_VALUES[2],
      actual: funnelOrder,
      fill: "#F97316"
    }
  ];

  const funnelprevFunnelMetrics = [
    {
      label: `Menu Opens`,
      value: STATIC_FUNNEL_VALUES[0],
      actual: selectedMenuOpenSecond,
      fill: "#5B5FC7"
    },
    {
      label: `Cart Builds`,
      value: STATIC_FUNNEL_VALUES[1],
      actual: selectedCartBuildSecond,
      fill: "#1F9D55"
    },
    {
      label: `Orders`,
      value: STATIC_FUNNEL_VALUES[2],
      actual: funnelOrderSecond,
      fill: "#D97706"
    }
  ];

  // 🚨 Auto flag bad funnel

    const calcChange = (curr, prev) => {
      if (!prev || prev === 0) {
        return curr > 0 ? "100.0" : "0.0";
      }
    
      return (((curr - prev) / prev) * 100).toFixed(1);
    };

    const calcChangeDrop = (current, previous) =>
      previous === 0 ? 0 : current - previous;




    const onSelectedSecondDate = (selectedDate)=>{

      const funnel_metrics = selectedRestData


    const funnelData = funnel_metrics.filter(
      (values) => values.period === selectedDate
    );

    const overallConversion = ((funnelData[0]?.orderMake / funnelData[0]?.menuOpen) * 100).toFixed(1)



    setSecOverallConvFunnel(overallConversion)



    setfunnelOrderSecond(funnelData[0].orderMake)
    setSelectMenuOpenSecond(funnelData[0].menuOpen)
    setSelectCartBuildSecond(funnelData[0].cartbuild)

    }

const onSelectedDate = (selectedDate) =>{

    const funnel_metrics = selectedRestData


    const funnelData = funnel_metrics.filter(
      (values) => values.period === selectedDate
    );

    const overallConversion = ((funnelData[0]?.orderMake / funnelData[0]?.menuOpen) * 100).toFixed(1)



    setOverallConvFunnel(overallConversion)

    


    setfunnelOrder(funnelData[0].orderMake)
    setSelectMenuOpen(funnelData[0].menuOpen)
    setSelectCartBuild(funnelData[0].cartbuild)

  }
  const newResData = async (value, label) => {
    try {
      setIsLoading(true);
  
      // UI updates
      setRestaurant(value);
      setSearch(label);
      setOpen(false);
  
      // API Call
      const detailsData = await api(
        `/swiggyrestaurant/${value}`
      );
  
  
      const summary = detailsData?.summary || [];
      const restIDs = detailsData?.available_rest_ids || [];
  
      // Store raw data immediately
      setSwiggyData(detailsData);
      setselectedRestData(summary);
  
      // Restaurant Header
      setRestaurantHeader(
        detailsData?.restaurant_name || ""
      );
  
      // Rest ID dropdown
      setAllSetID(restIDs);
  
      const selectRestId =
        restIDs.length > 1
          ? "All"
          : restIDs[0] || "";
  
      setRestId(selectRestId);
  
      // No summary data
      if (summary.length === 0) {
        console.warn("No summary data found");
  
        setCurrentMonthData(null);
        setPreviousMonthData(null);
  
        return;
      }
  
      // Current + Previous
      const currentMonth =
        summary[summary.length - 1];
  
      const prevMonth =
        summary.length > 1
          ? summary[summary.length - 2]
          : null;
  
      // Net Sales
      const currNetSale =
        (currentMonth?.gmv || 0) -
        (currentMonth?.discount || 0) - (currentMonth?.swiggyBurn || 0)
  
      const prevNetSale =
        prevMonth
          ? (prevMonth?.gmv || 0) -
            (prevMonth?.discount || 0) - (prevMonth?.swiggyBurn || 0)
          : 0;
  
      // Periods
      const allPeriods = dateConvert(summary);

      const overallConversion = ((currentMonth?.orderMake / currentMonth?.menuOpen) * 100).toFixed(1)
      const overallSecConversion = ((prevMonth?.orderMake / prevMonth?.menuOpen) * 100).toFixed(1)


      setOverallConvFunnel(overallConversion)
      setSecOverallConvFunnel(overallSecConversion)
  
      setPeriodList(allPeriods);
      setHeaderDates(allPeriods);
  
      // Sales
      setCurrentNetSales(currNetSale);
      setPreviousNetSales(prevNetSale);
  
      // Month Data
      setCurrentMonthData(currentMonth);
      setPreviousMonthData(prevMonth);
  
      // Funnel Current
      setSelectMenuOpen(
        currentMonth?.menuOpen || 0
      );
  
      setSelectCartBuild(
        currentMonth?.cartbuild || 0
      );
  
      setfunnelOrder(
        currentMonth?.orderMake || 0
      );
  
      // Funnel Previous
      setSelectMenuOpenSecond(
        prevMonth?.menuOpen || 0
      );
  
      setSelectCartBuildSecond(
        prevMonth?.cartbuild || 0
      );
  
      setfunnelOrderSecond(
        prevMonth?.orderMake || 0
      );
  
      // Selected Periods
      setSelectedPeriod(
        currentMonth?.period || ""
      );
  
      setSelectedPeriodSecFunnel(
        prevMonth?.period || ""
      );
  
      setheaderMonth(
        currentMonth?.period || ""
      );
  
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
  
    const handleEsc = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);



  const onSelectHeaderDate = (value) =>{

    const index = selectedRestData.findIndex(
      (item) => item.period === value
    );
    
    let currentMonth = null;
    let prevMonth = "";
    
    if (index !== -1) {
      currentMonth = selectedRestData[index];
    
      // Previous month exists
      if (index > 0) {
        prevMonth = selectedRestData[index - 1];
      }
    }

    const currNetSale =
    (currentMonth?.gmv || 0) -
    (currentMonth?.discount || 0) - (currentMonth?.swiggyBurn || 0)

  const prevNetSale =
    (prevMonth?.gmv || 0) -
    (prevMonth?.discount || 0) - (prevMonth?.swiggyBurn || 0);

    setCurrentNetSales(currNetSale);
    setPreviousNetSales(prevNetSale);
    
   
    setCurrentMonthData(currentMonth);
    setPreviousMonthData(prevMonth);

}


const onSelectRestID = (value)=>{


  try{
    setIsLoading(true);


  const summary = value === 'All'? swiggyData?.summary:swiggyData?.rest_ids[value]


  const currentMonth = summary[summary.length - 1];
  const prevMonth = summary[summary.length - 2];

 setselectedRestData(summary)


  // Net Sales
  const currNetSale =
    (currentMonth?.gmv || 0) -
    (currentMonth?.discount || 0) - (currentMonth?.swiggyBurn || 0);

  const prevNetSale =
    (prevMonth?.gmv || 0) -
    (prevMonth?.discount || 0) - (prevMonth?.swiggyBurn || 0);

  // Store data

  const allPeriods = dateConvert(summary);
  setPeriodList(allPeriods);
  setHeaderDates(allPeriods)




  setCurrentNetSales(currNetSale);
  setPreviousNetSales(prevNetSale);

  setCurrentMonthData(currentMonth);
  setPreviousMonthData(prevMonth);

  // Funnel current
  setSelectMenuOpen(currentMonth?.menuOpen || 0);
  setSelectCartBuild(currentMonth?.cartbuild || 0);
  setfunnelOrder(currentMonth?.orderMake || 0);

  // Funnel previous
  setSelectMenuOpenSecond(prevMonth?.menuOpen || 0);
  setSelectCartBuildSecond(prevMonth?.cartbuild || 0);
  setfunnelOrderSecond(prevMonth?.orderMake || 0);

  // Periods
  setSelectedPeriod(currentMonth?.period || "");
  setSelectedPeriodSecFunnel(prevMonth?.period || "");
  setheaderMonth(currentMonth?.period || "");

} catch (error) {
  console.error("API Error:", error);
} finally {
  setIsLoading(false);
}

}



  

  return (
    <>
    {
      isLoading? <span class="loader"> </span>
      :
      <>
<div className="p-6 bg-gray-100 min-h-screen overflow-x-hidden">     
   <h1 className="text-2xl font-bold mb-6">
        Swiggy Performance
       </h1>
       <div
  ref={dropdownRef}
  className="relative w-full transition-shadow focus-within:shadow-md mb-4"
>
  {/* Search Icon */}
  <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
    <svg
      className="w-6 h-6 text-gray-400"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1010.5 18a7.5 7.5 0 006.15-3.35z"
      />
    </svg>
  </div>

  {/* INPUT */}
  <input
    type="text"
    value={search}
    onChange={(e) => {
      setSearch(e.target.value);
      setOpen(true);
    }}
    onFocus={() => setOpen(true)}
    placeholder="Search restaurant..."
    className="
      w-full
      pl-12
      pr-4
      py-3
      border
      rounded-lg
      text-base
      bg-white
      focus:outline-none
      focus:ring-2
      focus:ring-indigo-500
    "
  />

  {/* DROPDOWN */}
  {open && (
    <div
      className="
        absolute
        top-full
        left-0
        z-50
        mt-2
        w-full
        bg-white
        border
        rounded-lg
        shadow-lg
        max-h-72
        overflow-y-auto
      "
    >
      {restaurantNames
        .filter((r) =>
          r.label.toLowerCase().includes(search.toLowerCase())
        )
        .map((r) => (
          <div
            key={r.value}
            onClick={() => {
              newResData(r.value, r.label);
            }}
            className="
              px-4
              py-3
              cursor-pointer
              hover:bg-gray-100
              text-base
            "
          >
            {r.label}
          </div>
        ))}

      {restaurantNames.filter((r) =>
        r.label.toLowerCase().includes(search.toLowerCase())
      ).length === 0 && (
        <div className="px-4 py-3 text-gray-400 text-base">
          No results
        </div>
      )}
    </div>
  )}
</div>
 
  

<div className="flex items-center justify-between gap-6 mb-2">
<div className="mt-1 mb-2 text-sm sm:text-base lg:text-lg font-semibold text-gray-700 break-words">
      Restaurant Name: {resturantHeader}
    
</div>
<div className="mt-1 mb-2 text-lg font-semibold text-gray-700 flex items-center gap-2">
  <span style={ {"margin-right": "8px"}}> Rest ID :</span>
        <select
          value={selectedRestId}
          onChange={(e) => {
            onSelectRestID(e.target.value);
            setRestId(e.target.value);
          }}
          className="border rounded-lg px-3 py-2"
        >
          {allrestID.length > 1 && (
            <option value="All">All</option>
          )}

          {allrestID.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
  
   </div>
<div className="mt-1 mb-2 text-lg font-semibold text-gray-700" >
        <select
          value={headerMonth}
          onChange={(e) => 
          {
            onSelectHeaderDate(e.target.value)
            setheaderMonth(e.target.value)
          }  
          }
          className="border rounded-lg px-3 py-2"
        >
          {selectheaderDate.map((p) => (
            <option key={p.raw} value={p.raw}>
              {p.formatted}
            </option>
          ))}
        </select>
    </div>

</div>

      {/* KPI STRIP (lightweight) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">

{/* Example KPI */}
<KpiCard
       title="Orders"
       value={currentMonthData.orders}
       percentage={ previousMonthData ? `${calcChange(currentMonthData?.orders,previousMonthData?.orders)}%`: ""}
       isUp={previousMonthData? currentMonthData?.orders > previousMonthData?.orders: null}
       gradient="bg-gradient-to-r from-orange-400 to-orange-600"
       dataKey="orders"
       logo={SwiggyLogo}
   
     />
 <KpiCard
       title="Gross Sales"
       value={`₹${Math.round(currentMonthData.gmv).toLocaleString()}`}
       percentage={ previousMonthData ? `${calcChange(currentMonthData?.gmv,previousMonthData?.gmv)}%`: ""}
       isUp={previousMonthData? currentMonthData?.gmv > previousMonthData?.gmv: null}
       gradient="bg-gradient-to-r from-orange-400 to-orange-600"
       dataKey="GMV"
       logo={SwiggyLogo}
   
     />
    <KpiCard
        title="Discount"
        value={`₹${Math.round(currentMonthData.discount).toLocaleString()}`}
        percentage={ previousMonthData ? `${calcChange(currentMonthData?.discount,previousMonthData?.discount)}%`: ""}
        isUp={previousMonthData? currentMonthData?.discount > previousMonthData?.discount: null}
        gradient="bg-gradient-to-r from-orange-400 to-orange-600"
        dataKey="gmv"
        logo={SwiggyLogo}

      />
      <KpiCard
       title="Net Sales"
       value={`₹${Math.round(currentNetSales).toLocaleString()}`}
       percentage={ previousMonthData ? `${calcChange(currentNetSales,previousNetSales)}%`: ""}
       isUp={previousMonthData? currentNetSales > previousNetSales: null}
       gradient="bg-gradient-to-r from-orange-400 to-orange-600"
       dataKey="orders"
       logo={SwiggyLogo}
     />
     <KpiCard
          title="Average Order Value"
          value={`₹${currentMonthData.aov}`}
          percentage={ previousMonthData ? `${calcChange(currentMonthData?.aov,previousMonthData?.aov)}%`: ""}
          isUp={previousMonthData? currentMonthData?.aov > previousMonthData?.aov: null}
          gradient="bg-gradient-to-r from-orange-400 to-orange-600"
          dataKey="aov"
          logo={SwiggyLogo}
        />
      <KpiCard
          title="Ad Spent"
          value={`₹${Math.round(currentMonthData.billed_amount).toLocaleString()}`}
          percentage={ previousMonthData ? `${calcChange(currentMonthData?.billed_amount,previousMonthData?.billed_amount)}%`: ""}
          isUp={previousMonthData? currentMonthData?.billed_amount > previousMonthData?.billed_amount: null}
          gradient="bg-gradient-to-r from-orange-400 to-orange-600"
          dataKey="adsBilled"
          logo={SwiggyLogo}
        />
          <KpiCard
          title="Total Burn"
          value={`₹${Math.round(currentMonthData?.swiggyBurn).toLocaleString()}`}
          percentage={ previousMonthData ? `${calcChange(currentMonthData?.swiggyBurn,previousMonthData?.swiggyBurn)}%`: ""}
          isUp={previousMonthData? currentMonthData?.swiggyBurn > previousMonthData?.swiggyBurn: null}
          gradient="bg-gradient-to-r from-orange-400 to-orange-600"
          dataKey="swiggyBurn"
          logo={SwiggyLogo}


/>
        <KpiCard
          title="Ads ROI"
          value={currentMonthData?.roi?.toLocaleString()}
          percentage={ previousMonthData ? `${calcChange(currentMonthData?.roi,previousMonthData?.roi)}%`: ""}
          isUp={previousMonthData? currentMonthData?.roi > previousMonthData?.roi: null}
          gradient="bg-gradient-to-r from-orange-400 to-orange-600"
          dataKey="roi"
          logo={SwiggyLogo}

/>

    
      </div>


      <div className="bg-white rounded-xl p-4 shadow mt-4 md:mt-5">

<div className="flex gap-2 mb-4 mt-6 ml-0 sm:ml-4 md:ml-[55px]">
  {["orders", "gmv", "aov", "discount"].map((metric) => (
    <button
      key={metric}
      onClick={() => setActiveMetric(metric)}
      className={`px-4 py-2 rounded-md text-sm font-medium transition
        ${activeMetric === metric
          ? "bg-indigo-600 text-white"
          : "bg-gray-200 text-gray-700 hover:bg-gray-300"}
      `}
    >
      {metric.toUpperCase()}
    </button>
  ))}
</div>


<ReusableBarChart
  data={selectedRestData}
  metric={activeMetric}
/>
</div>



       
      <div className="bg-white rounded-xl shadow p-6 space-y-4 mt-[15px] mb-5">
  {/* MAIN HEADER */}
  <div className="flex items-center justify-between">
    <h2 className="text-lg font-semibold text-gray-800">
      Conversion Funnel
    </h2>

    <span className="text-xs text-gray-500">
      Menu → Cart → Order
    </span>
  </div>

  {/* FUNNEL CARDS
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div className="bg-gray-50 rounded-lg p-4">
      <div className="text-sm font-semibold text-indigo-600 mb-3">
        This Month
      </div>
      <ConversionFunnel data={funnelThisMonth} />
    </div>

    <div className="bg-gray-50 rounded-lg p-4">
      <div className="text-sm font-semibold text-gray-600 mb-3">
        Last Month
      </div>
      <ConversionFunnel data={funnelLastMonth} />
    </div>
  </div>
</div> */}


<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
<div className="bg-gray-50 rounded-2xl p-6">

{/* TOP BAR */}
<div className="flex justify-end mb-6">

  <select
    value={selectedPeriod}
    onChange={(e) => {
      onSelectedDate(e.target.value);
      setSelectedPeriod(e.target.value);
    }}
    className="border rounded-xl px-4 py-3 bg-white shadow-sm"
  >
    {periodList.map((p) => (
      <option key={p.raw} value={p.raw}>
        {p.formatted}
      </option>
    ))}
  </select>

</div>

{/* FUNNEL */}
<ConversionFunnel
  data={funnellatestFunnelMetrics}
/>

{/* OVERALL CONVERSION */}
<div className="flex justify-center mt-8">

  <div
    className="
     bg-white
    border
    border-gray-200
    rounded-2xl
    shadow-sm
    px-4 sm:px-8
    py-5
    flex
    flex-col sm:flex-row
    items-start sm:items-center
    justify-between
    gap-4
    "
    style={{
      width: "100%"
    }}
  >

    {/* LEFT */}
    <div>

      <div className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
        Overall Conversion
      </div>

      <div className="text-gray-600 mt-1">
        Menu Opens → Orders
      </div>

    </div>

    {/* RIGHT */}
    <div className="text-5xl font-bold text-orange-500">
      {overallConvFunnel}%
    </div>

  </div>

</div>

</div>

<div className="bg-gray-50 rounded-2xl p-6">

{/* TOP BAR */}
<div className="flex justify-end mb-6">

  <select
    value={selectedPeriodSecFunnel}
    onChange={(e) => {
      setSelectedPeriodSecFunnel(
        e.target.value
      );

      onSelectedSecondDate(
        e.target.value
      );
    }}
    className="
      border
      border-gray-200
      rounded-xl
      px-4
      py-3
      bg-white
      shadow-sm
      font-medium
    "
  >
    {periodList.map((p) => (
      <option
        key={p.raw}
        value={p.raw}
      >
        {p.formatted}
      </option>
    ))}
  </select>

</div>

{/* FUNNEL */}
<ConversionFunnel
  data={funnelprevFunnelMetrics}
/>

{/* OVERALL CONVERSION */}
<div className="flex justify-center mt-8">

  <div
    className="
      relative
      overflow-hidden
      bg-white
      border
      border-gray-200
      rounded-3xl
      shadow-sm
      px-8
      py-5
      flex
      items-center
      justify-between
    "
    style={{
      width: "100%"
    }}
  >

    {/* GLOW */}
    <div
      className="
        absolute
        -top-12
        -right-10
        w-40
        h-40
        bg-blue-100
        rounded-full
        blur-3xl
        opacity-40
      "
    />

    {/* LEFT */}
    <div className="relative z-10">

      <div className="text-xs font-bold tracking-widest text-gray-400 uppercase">
        Overall Conversion
      </div>

      <div className="text-gray-600 mt-2 text-sm">
        Menu Opens → Orders
      </div>

    </div>

    {/* RIGHT */}
    <div className="relative z-10 text-right">

      <div className="text-5xl font-bold text-blue-600 tracking-tight">
        {overallSecConvFunnel}%
      </div>

    </div>

  </div>

</div>

</div>
  </div>
</div>

<div className="dashboardRow">
  <TrendCharts data={selectedRestData} />
  <AdsPerformance data={selectedRestData} />
</div>

{/* 
<ConversionRateTrend
  data={conversionTrendData.map(d => ({
    period: d.period,
    m2o: d.value   // reuse chart, label changes
  }))}
/> */}


<div className="bg-white rounded-xl p-6 shadow mt-4 md:mt-5 w-full">

  <h2 className="section-title">Customer Insights</h2>

  <div className="charts-row">

    {/* Row 1 */}
    <div className="chart-card">
      <UserSegmentDonut  selectedRestData={selectedRestData}/>
    </div>

    {/* Row 2 */}
    <div className="chart-card">
      <PieCharts pieTitle="Customer Lifecycle" selectedRestData={selectedRestData} />
    </div>

    <div className="chart-card ">
      <OrdersTrendChart selectedRestData={selectedRestData}/>
    </div>

    <div className="chart-card ">
      <MealPieCharts pieTitle="Meal Segment" selectedRestData={selectedRestData}/>
    </div> 

  </div>

</div>


<div className="bg-white rounded-xl p-6 shadow mt-4 md:mt-5 w-full">

  <MenuInsights selectedRestData={selectedRestData} />
        
</div>
</div>



    

      
      </>
    }
    </>
      );
}


function Kpi({ title, value, danger }) {
  return (
    <div className={`bg-white rounded-lg shadow p-4`}>
      <div className="text-sm text-gray-500">{title}</div>
      <div className={`text-2xl font-bold ${danger ? "text-red-600" : ""}`}>
        {value}
      </div>
    </div>
  );
}

function buildConversionTrend(data, type = "M2O") {
  if (!Array.isArray(data)) return [];

  return data
    .filter(d => d.menuOpen > 0) // remove invalid months
    .map(d => {
      let value = 0;

      if (type === "M2O") {
        value =
          d.menuOpen > 0
            ? (d.orderMake / d.menuOpen) * 100
            : 0;
      }

      if (type === "C2O") {
        value =
          d.cartbuild > 0
            ? (d.orderMake / d.cartbuild) * 100
            : 0;
      }

      return {
        period: d.period,
        value: Number(value.toFixed(1))
      };
    });
}



